export default "__VITE_ASSET__0dc08f70__"